import request from './request';

/**
 * 获取所有AI调用流程列表
 */
export function getFlows() {
  return request({
    url: '/prompt-simulator/flows',
    method: 'get'
  });
}

/**
 * 获取流程的所有步骤
 */
export function getSteps(flowId) {
  return request({
    url: `/prompt-simulator/flows/${flowId}/steps`,
    method: 'get'
  });
}

/**
 * 获取步骤的所有Worker
 */
export function getWorkers(stepId) {
  return request({
    url: `/prompt-simulator/steps/${stepId}/workers`,
    method: 'get'
  });
}

/**
 * 获取Worker详情
 */
export function getWorkerDetail(workerId) {
  return request({
    url: `/prompt-simulator/workers/${workerId}`,
    method: 'get'
  });
}

/**
 * 获取Worker配置中强制关联的知识列表
 */
export function getConfigKnowledge(workerId) {
  return request({
    url: `/prompt-simulator/workers/${workerId}/config-knowledge`,
    method: 'get'
  });
}

/**
 * 获取标签选项（按标签类型）
 */
export function getTags(tagType) {
  return request({
    url: `/prompt-simulator/tags/${tagType}`,
    method: 'get'
  });
}

/**
 * 获取所有可用的模型列表
 */
export function getModels() {
  return request({
    url: '/prompt-simulator/models',
    method: 'get'
  });
}

/**
 * 筛选知识
 */
export function filterKnowledge(params) {
  return request({
    url: '/prompt-simulator/filter-knowledge',
    method: 'post',
    data: params
  });
}

/**
 * 合并知识
 */
export function mergeKnowledge(params) {
  return request({
    url: '/prompt-simulator/merge-knowledge',
    method: 'post',
    data: params
  });
}

/**
 * 获取知识详情
 */
export function getKnowledgeDetails(params) {
  return request({
    url: '/prompt-simulator/get-knowledge-details',
    method: 'post',
    data: params
  });
}

/**
 * 生成提示词
 */
export function generatePrompt(params) {
  return request({
    url: '/prompt-simulator/generate-prompt',
    method: 'post',
    data: params
  });
}

/**
 * 调用模型
 */
export function callModel(params) {
  return request({
    url: '/prompt-simulator/call-model',
    method: 'post',
    data: params,
    timeout: 180000
  });
}

/**
 * 验证响应格式
 */
export function validateResponse(params) {
  return request({
    url: '/prompt-simulator/validate-response',
    method: 'post',
    data: params
  });
}

/**
 * 生成响应格式Schema
 */
export function generateResponseSchema(params) {
  return request({
    url: '/prompt-simulator/generate-response-schema',
    method: 'post',
    data: params
  });
}

/**
 * 生成提示词结构
 */
export function generatePromptStructure(params) {
  return request({
    url: '/prompt-simulator/generate-prompt-structure',
    method: 'post',
    data: params
  });
}

/**
 * 获取占位符列表
 */
export function getPlaceholders(category = null) {
  return request({
    url: '/prompt-simulator/placeholders',
    method: 'get',
    params: category ? { category } : {}
  });
}

/**
 * 获取历史执行计划列表
 */
export function getHistoryPlans(params) {
  return request({
    url: '/prompt-simulator/history-plans',
    method: 'get',
    params
  });
}

/**
 * 获取历史计划详情
 */
export function getHistoryPlanDetail(planId) {
  return request({
    url: `/prompt-simulator/history-plans/${planId}`,
    method: 'get'
  });
}
